import { useEffect, useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Briefcase } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";

export const ProfessionCard = () => {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["settings"], queryFn: api.settings });
  const [v, setV] = useState("");
  useEffect(() => setV(data?.profession || ""), [data?.profession]);
  const save = async (e) => {
    e.preventDefault();
    try {
      qc.setQueryData(["settings"], await api.saveSettings({ profession: v }));
      toast.success(v.trim() ? "Profession saved" : "Profession removed");
    } catch { toast.error("Couldn't save"); }
  };
  return (
    <form onSubmit={save} className="rounded-xl border border-white/10 bg-white/[0.03] p-4" data-testid="profession-card">
      <div className="flex items-center gap-2"><Briefcase size={16} className="text-sky-300" /><h3 className="font-display font-semibold">My profession</h3></div>
      <p className="text-xs text-slate-400 mt-1.5">Your friends can find you by what you do.</p>
      <div className="flex gap-2 mt-3">
        <Input value={v} onChange={(e) => setV(e.target.value)} maxLength={120} placeholder="e.g. Photographer" data-testid="profession-input" />
        <button type="submit" disabled={v.trim() === (data?.profession || "")} className="px-3 rounded-full text-xs bg-sky-400 text-[#06121c] hover:bg-sky-300 disabled:opacity-40 transition-opacity" data-testid="profession-save">Save</button>
      </div>
    </form>
  );
};
